import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  writeBatch,
  collectionGroup,
  orderBy,
} from 'firebase/firestore/lite';
import Skeleton from '@material-ui/lab/Skeleton';
import { Table } from 'antd';
import CouponManageDialog from './CouponDialog';
import moment from 'moment';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { useSelector } from 'react-redux';
import Switch from '@material-ui/core/Switch';
import { Tooltip } from 'antd';
import { makeStyles } from '@material-ui/core/styles';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

let couponsBackupArrChild = [];

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function NFTCouponsContainer(props) {
  const [codesList, setcodesList] = useState([]);
  const classes = useStyles();
  const columns = [
    {
      title: (
        <Tooltip title="NFT Title" mouseLeaveDelay={0}>
          {'NFT Title'}
        </Tooltip>
      ),
      dataIndex: 'tokenName',
      width: '20%',
      render: (text, obj) => (
        <Tooltip title={text} classes={classes}>
          <span>
            {text
              ? text.length > 24
                ? text.substring(0, 24) + '...'
                : text
              : '-'}{' '}
            {obj.sn ? '(#' + obj.sn + ')' : ''}
          </span>
        </Tooltip>
      ),
      sorter: (a, b) => {
        if (a.tokenName.toLowerCase() < b.tokenName.toLowerCase()) return -1;
        if (a.tokenName.toLowerCase() > b.tokenName.toLowerCase()) return 1;
        else return 0;
      },
    },
    {
      title: (
        <Tooltip title="Coupon" mouseLeaveDelay={0}>
          {'Coupon'}
        </Tooltip>
      ),
      dataIndex: 'buyWithCouponVal',
      render: (text) => {
        return (
          <div className="flex items-center">
            {text}
            {text && (
              <CopyToClipboard
                text={text}
                onCopy={() => {
                  toast.success('Copied.', {
                    position: 'bottom-left',
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    toastId: 'copyaddress',
                  });
                }}
              >
                <button
                  type="button "
                  style={{
                    width: '20px',
                    height: '20px',
                    position: 'relative',
                    zIndex: 20,
                  }}
                  className="ml-2"
                >
                  <ContentCopyIcon style={{ height: 18, width: 18 }} />
                </button>
              </CopyToClipboard>
            )}
          </div>
        );
      },
      sorter: (a, b) => {
        if (a.buyWithCouponVal < b.buyWithCouponVal) return -1;
        if (a.buyWithCouponVal > b.promoCode) return 1;
        else return 0;
      },
    },
  ];

  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const [loadingNfts, setloadingNfts] = useState(true);

  useEffect(() => {
    if (userDataRedux && userDataRedux.uid) {
      getNfts();
    }
  }, [userDataRedux]);

  const getNfts = async () => {
    let queryArr = [];
    queryArr.push(collection(firebaseFireStore, 'musicartNfts'));
    queryArr.push(where('adminState', '==', 'ACCEPT'));
    queryArr.push(where('activeInMarketPlace', '==', true));
    queryArr.push(where('usersId', 'array-contains', userDataRedux.uid));
    queryArr.push(orderBy('creationDate', 'desc'));
    let dataObj = await getDocs(query(...queryArr));

    let nftArr = [];
    dataObj.docs.map(async (ele, index) => {
      nftArr.push({ ...ele.data(), id: ele.id });
    });

    getNftsCouponsList([...nftArr]);
  };
  const getNftsCouponsList = async (walletOwnedNfts) => {
    let codesArr = [];

    let lCouponsArrChildern = [];
    let lCouponsArrMix = [];

    walletOwnedNfts.map((ele, indx) => {
      if (ele.isMultiple && ele.usersId.includes(userDataRedux.uid)) {
        let subCoupons = [];

        Object.values(ele.multipleNftDetails).map((ele2, indx2) => {
          if (
            ele2.userId === userDataRedux.uid &&
            ele2.buyWithCouponOnly &&
            ele2.activeInMarketPlace
          ) {
            lCouponsArrMix.push({
              buyWithCouponVal: ele2.buyWithCouponVal,
              tokenId: ele.tokenId,
              tokenName: ele.tokenName,
              sn: ele2.index,
              nftId: ele2.nftId,
            });

            subCoupons.push({
              buyWithCouponVal: ele2.buyWithCouponVal,
              tokenId: ele.tokenId,
              tokenName: ele.tokenName,
              sn: ele2.index,
              nftId: ele2.nftId,
            });
          }
        });

        if (subCoupons.length > 0) {
          lCouponsArrChildern.push({
            tokenName: subCoupons[0].tokenName,
            children: subCoupons.sort((x, y) => (x.sn > y.sn ? 1 : -1)),
            tokenId: subCoupons[0].tokenId,
          });
        }
      } else {
        if (ele.buyWithCouponOnly) {
          lCouponsArrChildern.push({
            buyWithCouponVal: ele.buyWithCouponVal,
            tokenId: ele.tokenId,
            tokenName: ele.tokenName,
            sn: 1,
          });
          lCouponsArrMix.push({
            buyWithCouponVal: ele.buyWithCouponVal,
            tokenId: ele.tokenId,
            tokenName: ele.tokenName,
            sn: 1,
          });
        }
      }
    });
    console.log('codesArr', codesArr);

    couponsBackupArrChild = lCouponsArrChildern;
    setcodesList(couponsBackupArrChild);
    setloadingNfts(false);
  };

  return (
    <div>
      <div className="nft-card-con">
        {loadingNfts && (
          <div
            className="flex 	w-full my-6 mx-6"
            style={{ flexDirection: 'column' }}
          >
            <Skeleton animation="wave" height={20} width="60%" />
          </div>
        )}

        {!loadingNfts && codesList.length === 0 && (
          <div className="text-center w-full text-blueGray-500">
            <p className="text-center">0 Coupons found</p>
          </div>
        )}

        {!loadingNfts && codesList.length > 0 && (
          <div className="w-full">
            <Table
              pagination={false}
              columns={columns}
              dataSource={codesList}
              showSorterTooltip={false}
            />
          </div>
        )}
      </div>
    </div>
  );
}
